import { render } from "./dataset-datasource.vue?vue&type=template&id=4c5f6256"
import script from "./dataset-datasource.vue?vue&type=script&lang=js"
export * from "./dataset-datasource.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__